import React from 'react'
import styled, { DefaultTheme, css } from 'styled-components'

import { TResponsiveProps, mediaQuery, responsiveStyle } from '@hozana/styling/responsive'

import { TContent, TTransformer, TTransformerOptions, convertHtmlStringToReactComponents } from '../functions'

export const PubliAndCommunityStyledDiv = styled.div`
  font-size: 17px; // 17px nunito = 16px OpenSans
  line-height: 1.45em;
  color: #222;
  font-family: ${(props) => props.theme.fontFamily.openSans};
  background-color: none;

  & * {
    hyphens: auto;
    word-wrap: break-word;
    word-break: break-word;
  }

  /* Commons */
  & img,
  & video,
  & iframe {
    max-width: 100%;
    padding: 0;
    margin-bottom: 16px;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  & #youtube-placeholder img {
    border-radius: 0px;
  }
  & img {
    border-radius: 16px;
  }

  & div,
  & p {
    margin-bottom: 8px;
    text-align: initial;
  }

  & p,
  & div,
  & em,
  & pre,
  & li,
  & span {
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
    color: ${(props) => props.theme.colors.secondaryTextContrastHigh};
    padding: 0;
    white-space: normal;
  }

  & em {
    font-style: italic;
  }

  & p span,
  & div span,
  & .hoz_quote p,
  & .hoz_important p {
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    padding: 0;
    margin: 0;
  }

  & p em,
  & div em {
    font-style: italic;
  }

  /* A */
  & div a,
  & div a span,
  & p a,
  & ul li a,
  & ol li a,
  & p a span {
    font-size: 17px;
    line-height: 28px;
    color: ${(props) => props.theme.colors.link};
    font-weight: normal;
    transition: 0.2s;
    padding: 0;
    pointer-events: auto;
    text-decoration: none;
  }

  & div a:hover,
  & div a span:hover,
  & p a:hover,
  & ul li a:hover,
  & ol li a:hover,
  & p a span:hover {
    color: ${(props) => props.theme.colors.darkBlue};
    text-decoration: underline;
  }

  & .hoz_quote {
    display: block;
    /* colors */
    color: ${(props) => props.theme.colors.secondaryTextContrastHigh};
    border-color: ${(props) => props.theme.colors.secondaryTextContrastLow};
    border-width: 0 0 0 2px;
    border-style: solid;
    /* spacing */
    margin-bottom: 16px;
    padding: 0 0 0 16px;
    /* text */
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
    font-style: italic;
  }

  & .hoz_quote em {
    color: ${(props) => props.theme.colors.black70};
    font-family: ${(props) => props.theme.fontFamily.openSans};
  }

  & .hoz_important {
    display: block;
    /* colors */
    color: ${(props) => props.theme.colors.primaryTextContrastDefault};
    background: ${(props) => props.theme.colors.whiteOrange};
    border-radius: ${(props) => props.theme.borderRadius.big};
    border: none;
    /* spacing */
    margin: 16px 0 12px 0;
    padding: 16px;
    /* text */
    font-weight: bold;
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
  }

  & .hoz_important a {
    font-family: ${(props) => props.theme.fontFamily.openSans} !important;
  }
  & .hoz_important em {
    color: ${(props) => props.theme.colors.yellow} !important;
    font-style: normal !important;
  }

  & .hoz_important a,
  & .hoz_quote a {
    font-size: 17px !important;
    line-height: 28px !important;
    color: ${(props) => props.theme.colors.link} !important;
    font-weight: bold !important;
  }
  & .hoz_important a:hover,
  & .hoz_quote a:hover {
    color: ${(props) => props.theme.colors.darkBlue} !important;
  }

  & ul,
  & ol {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 20px;
    text-align: initial;
    list-style: initial;
  }

  & iframe {
    max-height: 500px; // #iframeMaxHeight
    width: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 a,
  h2 a,
  h3 a,
  h4 a,
  h5 a,
  h6 a {
    font-family: ${(props) => props.theme.fontFamily.openSans};
    font-style: normal;
    color: ${(props) => props.theme.colors.darkBlue};
    line-height: 28px;
    margin-right: 0;
    margin-left: 0;
    margin-top: 24px;
    margin-bottom: 16px;
    padding: 0;
    font-weight: bold;

    font-size: 24px;
    ${mediaQuery('sm')} {
      font-size: 24px;
    }
    ${mediaQuery('md')} {
      font-size: 24px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 u,
  h2 u,
  h3 u,
  h4 u,
  h5 u,
  h6 u,
  h1 a,
  h2 a,
  h3 a,
  h4 a,
  h5 a,
  h6 a {
    text-decoration: none;
  }

  h1:not(.hoz_important) a,
  h2:not(.hoz_important) a,
  h3:not(.hoz_important) a,
  h4:not(.hoz_important) a,
  h5:not(.hoz_important) a,
  h6:not(.hoz_important) a {
    pointer-events: none;
    cursor: default;
    font-weight: bold;
  }

  h1,
  h1 strong,
  h1 b,
  h2,
  h2 strong,
  h2 b,
  h3,
  h3 strong,
  h3 b {
    font-weight: bold;
  }

  p + h1,
  div + h1,
  strong + h1,
  em + h1,
  a + h1,
  b + h1,
  ul + h1,
  pre + h1,
  blocquote + h1,
  p + h2,
  div + h2,
  strong + h2,
  em + h2,
  a + h2,
  b + h2,
  ul + h2,
  pre + h2,
  blocquote + h2,
  p + h3,
  div + h3,
  strong + h3,
  em + h3,
  a + h3,
  b + h3,
  pre + h3,
  ul + h3,
  blocquote + h3 {
    margin-top: 24px;
  }

  /** To publications generated from AELF API */
  .verse_number {
    font-size: 13px;
    vertical-align: text-top;
    font-weight: bold;
    color: ${(p) => p.theme.colors.darkRed};
  }
  .liturgy {
    &_complies__parole_ref,
    &_vepres__parole_ref,
    &_laudes__parole_ref {
      font-style: italic;
    }
    &_mass {
      &__lecture_ref,
      &__gospel_ref,
      &__psalm_ref {
        font-style: italic;
      }
    }
    &_mass__gospel_verse,
    &_mass__psalm_refrain_psalmique,
    &_vepres__psalm_antienne,
    &_laudes__psalm_antienne,
    &_complies__psalm_antienne {
      font-weight: bold;
      &_intro {
        font-size: 13px;
        color: ${(p) => p.theme.colors.darkRed};
      }
    }
  }
`

export const AnnouncementStyledDiv = styled.div`
  & p,
  & div,
  & em,
  & pre,
  & li,
  & span {
    font-size: 17px;
    line-height: 28px;
    color: ${(props) => props.theme.colors.black};
    padding: 0;
    white-space: normal;
    text-align: left !important;
  }

  & em {
    font-style: italic;
  }

  & p span,
  & div span {
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    padding: 0;
    margin: 0;
  }

  & p em,
  & div em {
    font-style: italic;
  }

  /* A */
  & div a,
  & div a span,
  & p a,
  & ul li a,
  & ol li a,
  & p a span {
    font-size: 17px;
    color: ${(props) => props.theme.colors.blue};
    font-weight: bold;
    transition: 0.2s;
    padding: 0;
    pointer-events: auto;
    text-decoration: none;
  }

  & div a:hover,
  & div a span:hover,
  & p a:hover,
  & ul li a:hover,
  & ol li a:hover,
  & p a span:hover {
    color: ${(props) => props.theme.colors.darkBlue};
    text-decoration: underline;
  }

  & ul,
  & ol {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 20px;
    text-align: initial;
    list-style: initial;
  }
`

const responsiveProps = { fontSize: 'font-size' } as const

type TStaticPageStyledDivProps = {
  mainFontFamily?: keyof DefaultTheme['fontFamily']
  titleFontFamily?: keyof DefaultTheme['fontFamily']
  lineHeight?: string
  imageWithBorder?: boolean
} & TResponsiveProps<typeof responsiveProps>

export const StaticPageStyledDiv = styled.div<TStaticPageStyledDivProps>`
  font-family: ${(props) => props.theme.fontFamily[props.mainFontFamily || 'openSans']};
  ${responsiveStyle(responsiveProps)};
  line-height: ${(props) => props.lineHeight || '1.45em'};
  a {
    color: ${(props) => props.theme.colors.mediumBlue};
    pointer-events: initial;
    text-decoration: none;
  }
  em {
    font-style: italic;
  }

  /* display on screen */
  .mobile {
    ${mediaQuery('sm')} {
      display: none;
    }
  }
  .desktop {
    ${mediaQuery('xs', 'xs')} {
      display: none;
    }
  }

  & img,
  & video,
  & iframe {
    max-width: 100%;
  }

  ${(props) =>
    props.imageWithBorder &&
    css`
      img {
        border: 1px solid #aaa;
        border-radius: ${(props) => props.theme.borderRadius.normal};
      }
    `}

  img,
  iframe {
    margin: 10px auto 20px;
    max-width: 100%;
    display: block;
  }

  a:hover {
    color: ${(props) => props.theme.colors.blue};
    text-decoration: underline;
  }
  a.no-underline:hover {
    text-decoration: none;
  }
  ul,
  ol {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding-left: 20px !important;
    list-style: initial !important;
    text-align: left !important;
  }
  ul ol,
  ul ul {
    list-style-type: circle;
  }

  p {
    margin-bottom: 0.5em;
    text-align: left !important;
  }

  p + h2,
  div + h2,
  strong + h2,
  em + h2,
  a + h2,
  b + h2,
  ul + h2,
  pre + h2,
  .guide-card__wrapper + h2,
  blocquote + h2 {
    margin-top: -1em;
    padding-top: 2.5em;
  }

  p + h3,
  div + h3,
  strong + h3,
  em + h3,
  a + h3,
  pre + h3,
  ul + h3,
  .guide-card__wrapper + h3 {
    margin-top: 1.5em;
  }

  h2 + h3 {
    margin-top: 1em;
  }

  h2 + p,
  h2 + ul,
  h2 + div,
  h2 + em,
  h2 + strong,
  h2 + pre,
  h2 + .guide-card__wrapper {
    margin-top: 1em;
  }

  h3 + p,
  h3 + ul,
  h3 + div,
  h3 + .guide-card__wrapper {
    margin-top: 1em;
  }
  .guide-card__wrapper + h3 {
    margin-top: 1em;
  }
  .guide-card__wrapper + h2 {
    margin-top: -1em;
    padding-top: 2.4em;
  }

  h2,
  h3 {
    line-height: 1em;
    text-align: left !important;
    line-height: 1.4em;
  }

  h2 {
    font-family: ${(props) => props.theme.fontFamily[props.titleFontFamily || 'montserrat']};
    font-size: 1.6em !important;
    font-weight: bold;
    color: ${(props) => props.theme.colors.darkBlue};
  }
  h3 {
    font-size: 1.4em !important;
    font-weight: normal;
    color: ${(props) => props.theme.colors.darkBlue};
  }
  & .primary {
    color: ${(props) => props.theme.colors.yellow};
  }
  & .secondary {
    color: ${(props) => props.theme.colors.darkBlue};
  }

  .guide-card__wrapper {
    max-width: 400px;
    background: white;
    margin: 1em auto 1em;
    padding-bottom: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    overflow: hidden;
  }

  .guide-card__image {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto 10px;
  }

  .guide-card__title {
    padding: 10px 1em;
    margin: 0;
    color: ${(props) => props.theme.colors.darkBlue};
    font-family: ${(props) => props.theme.fontFamily.montserrat};
    font-weight: bold;
    font-size: 1em;
  }
  .guide-card__title:hover {
    color: ${(props) => props.theme.colors.blue};
  }

  .guide-card__row {
    padding: 10px 1em 1em;
    justify-content: space-between;
    display: flex;
  }

  .guide-card__members {
    color: ${(props) => props.theme.colors.yellow};
    flex: 1;
    font-family: ${(props) => props.theme.fontFamily.openSans};
    margin: auto;
    line-height: 1em;
  }

  .hoz_important {
    color: ${(props) => props.theme.colors.yellow};
    background: ${(props) => props.theme.colors.whiteOrange};
    padding: 20px;
    border-radius: 16px;
    margin: 1em 0;
  }
`

type TExternalContentProps = {
  onClick?: React.MouseEventHandler<HTMLElement>
  content: TContent
  transformers?: TTransformer[]
  options?: TTransformerOptions
}

type TStaticPageProps = TExternalContentProps & Pick<TStaticPageStyledDivProps, 'imageWithBorder'>

export const ExternalContent: TFCC<TExternalContentProps> & {
  Publication: TFCC<TExternalContentProps>
  Community: TFCC<TExternalContentProps>
  StaticPage: TFCC<TStaticPageProps>
  Announcement: TFCC<TExternalContentProps>
} = ({ content, transformers, options }) => <>{convertHtmlStringToReactComponents(content, transformers, options)}</>

const PubliAndCommunity = React.memo<TExternalContentProps>(({ content, onClick, options }) => (
  <PubliAndCommunityStyledDiv onClick={onClick}>
    <ExternalContent content={content} options={options} />
  </PubliAndCommunityStyledDiv>
))

const Announcement = React.memo<TExternalContentProps>(({ content }) => (
  <AnnouncementStyledDiv>
    <ExternalContent content={content} />
  </AnnouncementStyledDiv>
))

const StaticPage = React.memo<TStaticPageProps>(({ content, imageWithBorder }) => (
  <StaticPageStyledDiv fontSize={{ xs: '1rem', md: '1em', lg: '1.15rem' }} imageWithBorder={imageWithBorder}>
    <ExternalContent content={content} />
  </StaticPageStyledDiv>
))

PubliAndCommunity.displayName = 'PubliAndCommunity'
Announcement.displayName = 'Announcement'
StaticPage.displayName = 'StaticPage'

ExternalContent.Publication = PubliAndCommunity
ExternalContent.Community = PubliAndCommunity
ExternalContent.StaticPage = StaticPage
ExternalContent.Announcement = Announcement
